<template>
  <v-container grid-list-lg>
    <v-layout column>
      <v-flex v-if="Location">
        <v-card>
          <v-card-title primary-title>
            <v-layout row wrap align-center>
              <v-flex>
                <v-icon v-if="isLocked" color="red">mdi-lock</v-icon> Location
              </v-flex>
              <!-- <v-spacer></v-spacer>
              <v-flex shrink>
                Lock
                <toggle-button
                  :disabled="isLocked.disabled"
                  @change="updateLock"
                  v-model="isLocked"
                  :labels="true"
                  :sync="true"
                ></toggle-button>
              </v-flex> -->
            </v-layout>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text primary-title>
            <v-layout column>
              <v-flex class="text-xs-left">
                <v-layout row wrap align-center>
                  <v-flex>
                    <p>Lock Location</p>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink>
                    <toggle-button
                      :disabled="isLocked.disabled"
                      @change="updateLock"
                      v-model="isLocked"
                      :labels="true"
                      :sync="true"
                    ></toggle-button>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex class="text-xs-left">
                <v-layout row wrap align-center>
                  <v-flex>
                    <p>Self Paying</p>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink>
                    <toggle-button
                      @change="updateSelfPaying"
                      v-model="selfPaying"
                      :labels="true"
                      :sync="true"
                    ></toggle-button>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text>
            <div class="text-xs-center" v-if="Location.logoURL">
              <img :src="Location.logoURL" height="55" width="200" />
            </div>
            <v-layout row wrap>
              <v-flex xs6>
                <div class="title">{{ Location.name }}</div>
                <div>{{ Location.Address.addressLine1 }}</div>
                <div>
                  {{ Location.Address.city }},
                  {{ Location.Address.State.code.split("-")[1] }}
                  {{ Location.Address.postalCode }}
                </div>
                <div>{{ Location.Address.phoneNumber }}</div>
                <div>{{ Location.email }}</div>
                <div>{{ Location.website }}</div>
                <div class="mt-2">
                  <span>{{ $t("labels.createdAt") }}: </span>
                  <span class="font-weight-medium"
                    >{{ Location.createdAt | moment("LL") }} |
                    {{ Location.createdAt | moment("from", "now") }}</span
                  >
                </div>
              </v-flex>
              <v-flex xs6 class="text-xs-right">
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        class="pointer"
                        v-on="on"
                        v-bind="attrs"
                        @click="copyCode(Location.code)"
                      >
                        <span class="font-weight-medium">Code:</span>
                        <span>{{ Location.code }}</span>
                      </div>
                    </template>
                    <span class="text-xs-right">Click To Copy</span>
                  </v-tooltip>
                </div>
                <div>
                  <span class="font-weight-medium">Type:</span>
                  {{ Location.type }}
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex v-if="Organization">
        <v-card>
          <v-card-title primary-title> Organization </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6>
                <div class="title">{{ Organization.name }}</div>
                <div>{{ Organization.phoneNumber }}</div>
                <div>{{ Organization.email }}</div>
              </v-flex>
              <v-flex xs6 class="text-xs-right">
                <div>
                  <span class="font-weight-medium">Location Count: </span>
                  {{ Organization.Locations.length }}
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex v-if="User">
        <v-card>
          <v-card-title primary-title> Users </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="User"
              :total-items="count"
              item-key="id"
              :pagination.sync="pagination"
              :rows-per-page-items="rowsPerPageItems"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left pointer">
                    {{ props.item.createdAt | moment("MM/DD/YYYY LT") }}
                  </td>
                  <td class="text-xs-left pointer">
                    <div>
                      <div>{{ props.item.name }}</div>

                      <!-- <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <small
                            v-bind="attrs"
                            id="locationCode"
                            @click="copyCode(props.item.code)"
                            v-on="on"
                            class="text-caption"
                            >{{ props.item.code }}</small
                          >
                        </template>
                        <span>Click To Copy</span>
                      </v-tooltip> -->
                    </div>
                  </td>
                  <!-- <td class="text-xs-left pointer">
              <a @click="openGoogleMap(props.item)">{{ props.item.address }}</a>
            </td> -->
                  <td class="text-xs-left">
                    {{ props.item.phoneNumber }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.email }}
                  </td>
                </tr>
              </template>
              <!-- <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
                >Your search for "{{ search }}" found no results.</v-alert
              > -->
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import bonventaService from '@/modules/Bonventa/service.js';

export default {
  name: 'location-profile',
  data() {
    return {
      id: null,
      isLocked: false,
      Location: null,
      Organization: null,
      User: null,
      selfPaying: true,
      rowsPerPageItems: [10, 25, 50, 100],
      count: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: 'name',
      },
      headers: [
        {
          text: 'Created At',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Name',
          value: 'name',
          sortable: false,
        },
        {
          text: this.$t('labels.phoneNumber'),
          value: 'businessPhone',
          sortable: true,
        },
        {
          text: this.$t('labels.address'),
          value: 'address',
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.getLocation();
  },
  methods: {
    async updateSelfPaying(val) {
      bonventaService.Location.update(this.id, {
        selfPaying: this.selfPaying,
      }).then(() => {
        this.$swal
          .mixin({
            toast: true,
            showConfirmButton: true,
            position: 'top-end',
            timer: 3000,
          })
          .fire({
            type: 'success',
            title: 'Self paying status was updated!',
          });
      })
      .catch(error => {
        console.log('error i s:', error)
        this.selfPaying = !this.selfPaying;
      })
    },
    async updateLock(val) {
      console.log('val', val);
      if (val.value) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You want to lock this customer',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then((result) => {
          if (result.value) {
            this.updateLocation();
            // this.$Progress.start()
          } else {
            this.isLocked = !this.isLocked;
          }
        });
      } else {
        this.updateLocation();
      }
    },
    updateLocation() {
      if (this.Location.metadata) {
        this.Location.metadata.isLocked = this.isLocked;
      } else {
        this.Location.metadata = { isLocked: this.isLocked }
      }
      bonventaService.Location.update(this.id, {
        metadata: this.Location.metadata,
      }).then(() => {
        this.$swal
          .mixin({
            toast: true,
            showConfirmButton: true,
            position: 'top-end',
            timer: 3000,
          })
          .fire({
            type: 'success',
            title: 'Location status was updated!',
          });
      });
    },
    copyCode(code) {
      // const copyText = code
      // console.log('copyText', copyText.innerHTML);

      navigator.clipboard.writeText(code);
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });

      Toast.fire({
        type: 'success',
        title: 'Location code was copy',
      });
      // this.$toast.success("Location code was copy", { timeout: 2000 });
    },
    getLocation() {
      if (!this.$route.params || !this.$route.params.id) {
        return this.$router.push('/bonventa/location');
      }
      this.id = this.$route.params.id;
      bonventaService.Location.getById(this.id).then((response) => {
        console.log('result', response);
        this.Location = response.data;
        if (this.Location) {
          this.selfPaying = this.Location.selfPaying;
          if (this.Location.metadata && this.Location.metadata.isLocked) {
            this.isLocked = this.Location.metadata.isLocked;
          }
          this.getOrganization();
        }
        // this.pagination.totalItems = this.count;
      });
    },
    getOrganization() {
      bonventaService.Organization.getById(this.Location.OrganizationId, {
        includeLocation: true,
      }).then((response) => {
        console.log('Organization result', response);
        this.Organization = response.data;
        this.getUser();
        // this.pagination.totalItems = this.count;
      });
    },
    getUser() {
      bonventaService.User.getAll({
        organizationId: this.Location.OrganizationId,
      }).then((response) => {
        console.log('User result', response);
        this.User = response.data;
        this.count = response.count;
        // this.pagination.totalItems = this.count;
      });
    },
  },
};
</script>

<style scoped>
</style>
